import { application } from "../application"
import RegistrationController from "./registration_controller"

application.register("auth--registration", RegistrationController)
